import React, { useEffect,useState} from 'react'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { NavLink } from 'react-router-dom';
import { useAappContext} from '../context/AppContext';

const ProductGroup = () => {
const {getProductCategory, productCategory:category} = useAappContext();

    useEffect(()=>{
        getProductCategory()
    },[])
    
  return (
    <>{
      category.map((curElem)=>{
            return (
                <Group key={curElem.id} {...curElem} ></Group>
            )
        })
    }
               
         </>
  )
}

export default ProductGroup





export const Group = (profs) => {
    const {onClicktoGet, getApiData,apiData:subcategory} = useAappContext();
useEffect(()=>{
  getApiData('/psubcategory/')
},[])




  return (
    <div className="main-product-group">
    <div className="group-name">
      <NavLink onClick={()=>{onClicktoGet(profs.id,profs.name)}} to={'/products/'+profs.name}>{profs.name}</NavLink>
    </div>
        <div className='sub-group'>
       {
      
        
        subcategory.map((subCategory)=>{
          const{category,id}=subCategory;
          return (
            < div style={{width:'100%'}} key={id}>
            {category === profs.id ? <Submanu  {...subCategory}  /> : '' }
            </div>
          )  
        })
       }
      

        </div>
    </div>
  )
}

export const Submanu = (subManu) => {
  const{id,name,category}=subManu;
  const {getScategory,categoryId} = useAappContext();
  const [categoryName, setCategory] = useState(null);
  const {getProductCategory, productCategory:pcategory} = useAappContext();
   useEffect(()=>{
      getProductCategory()
  },[])


  useEffect(() => {
    if (pcategory && categoryId) {
      const matchedCategory = pcategory.find(cat => cat.id === parseInt(categoryId));
      setCategory(matchedCategory || null);
    }
  }, [pcategory, categoryId]);

   const ctgName = categoryName?.name
  
  
 

  return (
    <> 
    <NavLink onClick={()=>{getScategory(id,name,category,ctgName);}} to={'/products/'+ctgName+' of '+name}><DoubleArrowIcon style={{fontSize:14,marginTop:2,marginRight:3}}/>
      {name}
    </NavLink>
</>
  )
}
